import { createAuthClient } from "better-auth/react";
import { dashClient, sentinelClient } from "@better-auth/infra/client";
import { passkeyClient } from "@better-auth/passkey/client";
import { getApiBaseUrl } from "@apps/dashboard/lib/env";

function sessionUrlWithNoCookieCache(url: string): string {
  if (!url.includes("/get-session") || url.includes("disableCookieCache=")) {
    return url;
  }
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    parsed = new URL(url, `${getApiBaseUrl()}/`);
  }
  parsed.searchParams.set("disableCookieCache", "true");
  return parsed.href;
}

/**
 * Cliente Better Auth → misma base que `BETTER_AUTH_URL` / `API_URL` en la API.
 * Rutas montadas en Nest: `/api/auth/*` (main.ts).
 *
 * Todas las llamadas a `get-session` añaden `disableCookieCache=true` para no fiarse
 * solo del cache en cookie (puede mostrar sesión obsoleta; en localhost las cookies
 * se comparten entre puertos).
 */
export const authClient = createAuthClient({
  baseURL: getApiBaseUrl(),
  plugins: [dashClient(), sentinelClient(), passkeyClient()],
  fetchOptions: {
    credentials: "include",
    async onRequest(ctx) {
      const href = typeof ctx.url === "string" ? ctx.url : ctx.url.href;
      const next = sessionUrlWithNoCookieCache(href);
      if (next === href) return;
      return { ...ctx, url: next };
    },
  },
});
